import { render, staticRenderFns } from "./manualNot.vue?vue&type=template&id=22611d1e&scoped=true&"
import script from "./manualNot.vue?vue&type=script&lang=js&"
export * from "./manualNot.vue?vue&type=script&lang=js&"
import style0 from "./manualNot.vue?vue&type=style&index=0&id=22611d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22611d1e",
  null
  
)

export default component.exports